<template>
  <div class="return">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <div class="space"></div>
      <b-container>
        <div class="segmented-control">
          <input
            type="radio"
            name="radio2"
            v-model="radio_btn"
            @change="onChange"
            value=""
            id="tab-1"
            checked
          />
          <label for="tab-1" class="segmented-control__1">
            <p>คืนแล้ว</p></label
          >
          <input
            type="radio"
            name="radio2"
            v-model="radio_btn"
            @change="onChange"
            value="return"
            id="tab-2"
          />
          <label for="tab-2" class="segmented-control__2">
            <p>รายการยืม</p>
          </label>

          <input
            type="radio"
            name="radio2"
            v-model="radio_btn"
            @change="onChange"
            value="scan"
            id="tab-3"
          />
          <label for="tab-3" class="segmented-control__3">
            <p>Scan เพื่อคืน</p>
          </label>

          <div class="segmented-control__color"></div>
        </div>
        <!-- ========================================= TAB DETAIL =================================================== -->
        <br />
        <!-- ========================================= คืนแล้ว ======================================================= -->
        <div class="detail" v-if="radio_btn === ''">
          <div class="card-columns">
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <b-table striped hover :items="items" :fields="fields" class="text-left"></b-table>
              </div>
            </div>
          </div>
        </div>
        <!-- ========================================== END ======================================================== -->
         <!-- ========================================= รายการคืน =================================================== -->
         <div class="detail" v-if="radio_btn === 'return'">
          <div class="card-columns">
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <b-table striped hover :items="items" :fields="fields" class="text-left"></b-table>
              </div>
            </div>
          </div>
        </div>
         <!-- ========================================== END ======================================================== -->
          <!-- ========================================= รายการคืน =================================================== -->
         <div class="detail" v-if="radio_btn === 'scan'">
          <div class="card-columns">
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                
              </div>
            </div>
          </div>
        </div>
         <!-- ========================================== END ======================================================== -->
        <!-- ========================================== END ========================================================  -->
      </b-container>
      <!-- ============================================= MODAL =====================================================================  -->

      <!-- ============================================== END =====================================================================-->
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
// import axios from "axios";
// import { StreamBarcodeReader } from "vue-barcode-reader";
// import CryptoJS from "crypto-js";
import moment from "moment";
// import { getDistance } from "geolib";
export default {
  name: "ubrucoffee",
  components: { sidebar_user },
  props: {
    msg: String,
  },
  data() {
    return {
      radio_btn: "",
      fields: [
          {
            key: 'last_name',
            label: 'ชื่อหนังสือ',
            sortable: true
          },
          {
            key: 'first_name',
            label: 'วันส่งคืน',
            sortable: false
          },
          
          {
            key: 'duedate',
            label: 'กำหนดส่ง',
            sortable: false
          },
          {
            key: 'barcode',
            label: 'บาร์โค้ด',
            sortable: false
          },
          {
            key: 'age',
            label: 'สถานะ',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          }
        ],
        items: [
          { isActive: true, age: 40, first_name: '10/12/2024', last_name: 'Once aponTime',barcode:"12343",duedate:'10/11/2024' },
          { isActive: false, age: 21, first_name: '10/12/2024', last_name: 'Computur',barcode:"56843",duedate:'10/11/2024' },
          { isActive: false, age: 89, first_name: '10/25/2024', last_name: 'THAILAND',barcode:"97533" ,duedate:'10/11/2024'},
          { isActive: true, age: 38, first_name: '10/30/2024', last_name: 'Singpo',barcode:"95875",duedate:'10/11/2024' }
        ]
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  mounted() {},
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    // https://smartlibrary.ubru.ac.th/loan/borrow
    login() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}
.space {
  height: 30px;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0rem;
  left: 0rem;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 20.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  left: 0rem;
  top: 0rem;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 7rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 7rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6.4rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(13rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/
.card-columns .card {
  border-radius: 20px;
}

/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }

  .on-line {
    width: 6%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .on-line {
    /* width: 8%; */
    height: auto;
  }
  .card-columns-left-item {
    column-count: 2;
  }
}

@media (max-width: 667px) {
  .on-line {
    width: 11%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
/*End*/
</style>
